/* eslint-disable import/no-unused-modules */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { IconKebab } from 'svgIcons/MotionPortalIcons';
import './style.scss';
import listenForOutsideClicks from 'sharedComponents/ContextMenu/helper';

const ContextMenuComponent = ({ isOpen, setContextMenuId, id, ...props }) => {
	const menuRef = useRef(null);
	const [listening, setListening] = useState(false);
	useEffect(listenForOutsideClicks(listening, setListening, menuRef, setContextMenuId));
	const toggle = () => {
		if (isOpen) {
			setContextMenuId(null);
		} else {
			setContextMenuId(id);
		}
	};
	const handleSelection = (option) => {
		toggle();
		const callbackFunction = option.onOptionSelect || props.onSelect;

		if (typeof callbackFunction === 'function') {
			callbackFunction(option.id);
		}
	};

	const buttonClass = isOpen ? 'context-menu-button-active' : 'context-menu-button';
	return (
		<div className='context-menu' ref={menuRef} role='menu'>
			<div
				id={id}
				className={buttonClass}
				onClick={() => { toggle(); }}
				tabIndex={0}
				role='button'
				aria-haspopup='true'
				aria-expanded={isOpen}
				onKeyDown={e => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						toggle();
					}
				}}
			>
				<IconKebab active={isOpen} />
			</div>
			{isOpen &&
				<div className='context-menu-list'>
					{props.options.map(option => {
						const cssClass = option.disabled === true ? 'context-menu-list-item-disabled' : 'context-menu-list-item';
						return (
							<div
								id={`contextMenuItem_${option.id}`}
								key={`contextMenuItem_${option.id}`}
								className={cssClass}
								role='menuitem'
								tabIndex={option.disabled ? -1 : 0}
								aria-disabled={option.disabled}
								onClick={() => {
									if (option.disabled !== true) {
										handleSelection(option);
									}
								}}
								onKeyDown={e => {
									if (
										option.disabled !== true &&
										(e.key === 'Enter' || e.key === ' ')
									) {
										e.preventDefault();
										handleSelection(option);
									}
								}}
							>
								{option.title}
							</div>
						);
					}
					)}
				</div>
			}
		</div>
	);
};

ContextMenuComponent.defaultProps = {
	id: '',
	options: [],
	onSelect: undefined,
	isOpen: false,
	setContextMenuId: () => { },
};

ContextMenuComponent.propTypes = {
	id: PropTypes.string, // Unique identifier for the context menu
	options: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Option ID
			title: PropTypes.string, // Option title
			disabled: PropTypes.bool, // Whether the option is disabled
			onOptionSelect: PropTypes.func, // Callback for option selection
		})
	), // Array of menu options
	onSelect: PropTypes.func, // Callback for menu selection
	isOpen: PropTypes.bool, // Whether the context menu is open
	setContextMenuId: PropTypes.func, // Function to set the active context menu ID
};

export default React.memo(ContextMenuComponent);
